import styled from 'styled-components';

export const EditingContainer = styled.div<{
  $hasValidationError?: boolean;
  $validationStatus?: 'active' | 'fading' | null;
}>`
  padding: 0;
  margin: 0;
  background: white;
  display: flex;
  align-items: center;
  width: 100%;
  max-width: 100%;
  white-space: nowrap;
  overflow: visible;
  position: relative;
  box-sizing: border-box;
  font-size: 0.7rem;
  line-height: 1.2;

  .MuiFormControl-root,
  .MuiTextField-root,
  .MuiAutocomplete-root {
    width: 100% !important;
    margin: 0;
    box-sizing: border-box;
  }

  .MuiTextField-root input[type='datetime-local'] {
    min-width: 10px;
  }

  .MuiAutocomplete-root .MuiOutlinedInput-root {
    border: none !important;
    outline: none !important;
    border-radius: 0 !important;
    background: transparent !important;
    min-height: 18px !important;

    &:hover {
      background: transparent !important;
    }

    &.Mui-focused {
      border: none !important;
      outline: none !important;
      background: transparent !important;
    }

    .MuiOutlinedInput-notchedOutline,
    &.Mui-focused .MuiOutlinedInput-notchedOutline {
      border: none !important;
    }
  }

  .MuiAutocomplete-root .MuiInputBase-input {
    padding: 0 !important;
    background: transparent !important;
    color: inherit !important;
    font-size: inherit !important;
    line-height: 1.2em !important;
  }

  .MuiOutlinedInput-root {
    border: none;
    outline: none;
    border-radius: 0;
    background: white;
    min-height: 0;

    .MuiOutlinedInput-notchedOutline,
    &.Mui-focused .MuiOutlinedInput-notchedOutline {
      border: none;
    }
  }

  .MuiInputBase-input {
    padding: 0;
    background: white;
    height: auto;
    min-height: 0;
    line-height: 1.2em;

    &[type='datetime-local'] {
      padding: 4px 8px;
      color: inherit;
    }
  }

  ${(props) =>
    props.$hasValidationError &&
    props.$validationStatus === 'active' &&
    `
    .MuiInputBase-input,
    .MuiAutocomplete-root .MuiInputBase-input {
      color: #d32f2f !important;
      transition: color 0.3s ease;
    }
  `}

  ${(props) =>
    props.$hasValidationError &&
    props.$validationStatus === 'fading' &&
    `
    .MuiInputBase-input,
    .MuiAutocomplete-root .MuiInputBase-input {
      color: inherit !important;
      transition: color 1s ease;
    }
  `}
`;

export const DisplayContainer = styled.div`
  width: 100%;
  cursor: text;
  display: flex;
  align-items: center;
  padding: 0;
  position: relative;
  box-sizing: border-box;
  line-height: 1.2;
`;

export const ExpandedDisplayContainer = styled(DisplayContainer)`
  min-width: 200px !important;
  min-height: inherit;
  height: 100%;
`;
